import { playerStoreKeys } from '../playerStoreConstants'
import { useSetPlayerStoreData } from '../hooks'
import { config } from '../../../../components/Init/Init'

export const useSetPlayerSocialBankroll = () => {
  const { setPlayerStoreData } = useSetPlayerStoreData()

  const setPlayerSocialBankroll = amount => {
    if (config.enableSweepstakes && amount !== null && !isNaN(amount)) {
      setPlayerStoreData(
        {
          [playerStoreKeys.socialBankroll]: amount
        },
        'setPlayerSocialBankroll'
      )
    }
  }
  return { setPlayerSocialBankroll }
}
